import React, { FunctionComponent, useEffect, useMemo, useRef, useState } from "react";
import { getFullName } from "../../../../../utils/NamesUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faShareSquare, faUserTimes } from "@fortawesome/free-solid-svg-icons";
import {
  CoachTeacherRelationshipRequest,
  DataSharingTableData,
  SupervisorEducatorRelationshipRequest,
  TeacherInfo,
} from "../../../../../store/onboarding/types";
import { bindActionCreators, Dispatch } from "redux";
import {
  //openDataSharingEditModal,
  removeEducatorsFromSupervisors,
  removeTeachersFromCoaches,
} from "../../../../../store/onboarding/actions";
import { connect, useDispatch } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { StaffRelationship, UserAssignmentRole, UserInfo } from "../../../../../store/auth/types";
import { showConfirmDialog } from "../../../../../store/confirm-dialog/actions";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";

type OwnProps = {
  educator: UserInfo;
  eductorStaffRelation?: StaffRelationship;
  onHandleEditRow: (eductorStaffRelation:StaffRelationship) => any;
};

type StateProps = {
  selectedEmployee?: TeacherInfo;
};



type DispatchProps = {
  removeTeachersFromCoaches: (
    relationship: CoachTeacherRelationshipRequest
  ) => any;
  removeEducatorsFromSupervisors: (
    relationship: SupervisorEducatorRelationshipRequest
  ) => any;
};

type Props = OwnProps & StateProps & DispatchProps;

const EducatorListItem: FunctionComponent<Props> = ({
  selectedEmployee,
  educator,
  eductorStaffRelation,
  onHandleEditRow,
  removeTeachersFromCoaches,
  removeEducatorsFromSupervisors,
}) => {
  const dispatch = useDispatch();
  const targetEmployeeIsCoach = useMemo(
    () =>
      selectedEmployee?.user.profile.current_assignment?.role ===
      UserAssignmentRole.COACH,
    [selectedEmployee]
  );

  const handleTeacherRemove = (educator: UserInfo) => {
    if (targetEmployeeIsCoach) {
      removeTeachersFromCoaches({
        coach: selectedEmployee!.user.id,
        teacher: educator.id,
      });
    } else {
      removeEducatorsFromSupervisors({
        supervisor: selectedEmployee!.user.id,
        user: educator.id,
      });
    }
  };

  const handlePasswordResetConfirm = () => {
    const onConfirm = () => {
      if (selectedEmployee!.user.id) {
        handleTeacherRemove(educator);
      }
    };
    dispatch(
      showConfirmDialog({
        onConfirm,
        centered: true,
        title: "Remove Educator",
        text: (
          <>
            <p className="font-weight-bold text-center mb-2">Are you sure you want to remove this educator?</p>
            <p className="text-center">They will be moved to <i>Previous Educators</i>. Shared data periods will no longer be accessible, and collaboration on intervention cases in ReadyCoach will end. </p>
            <p className="text-center">
              <FontAwesomeIcon 
                icon={faExclamationTriangle}
                style={{color:'red'}}
              /> {" "}
              <i>This action cannot be undone.</i>
            </p>
          </>
        ),
        confirmButtonText: "YES, REMOVE",
      })
    );
  };

  return (
    <tr>
      <td>
        {getFullName(educator)}
      </td>
      <td className="text-right pr-3">
        <OverlayTrigger
          overlay={<Popover id="remove-educator-Popover" className="p-2">Remove Educator</Popover>}
        >
          <span onClick={() => handlePasswordResetConfirm()}>
            <FontAwesomeIcon icon={faUserTimes} className="pointer" />
            </span>
          </OverlayTrigger>
      </td>
    </tr>
  );
};

const mapStateToProps = ({ onboarding }: ApplicationState): StateProps => {
  return {
    selectedEmployee: onboarding.selectedTeacher
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      removeTeachersFromCoaches: removeTeachersFromCoaches,
      removeEducatorsFromSupervisors: removeEducatorsFromSupervisors,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(EducatorListItem);
